<template>
  <b-row align-content="start" border-variant="primary" class="py-1 mb-2 border-bottom border-light text-left">
    <b-col cols="4" class="text-dark font-weight-bold">{{ title }}</b-col>
    <b-col cols="6">
      <div class="text-dark" v-if="changeType==='phoneNumber'">
        <b-row>
          <b-col class="ml-1 pl-0">{{data}}</b-col>
        </b-row>
      </div>
      <div v-else class="text-dark">{{data}}</div>
    </b-col>
    <b-col cols="2">
      <template v-if="canChangeDefaultItem">
        <b-button variant="outline-primary" size="sm" @click="changeUnitDetail" v-b-tooltip.hover.topright :title="editLabelOrDefault">
          <b-icon icon="pencil-fill"></b-icon>
        </b-button>
      </template>
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: "UnitDetailRowItem",
  props: {
    title: {type: String},
    data: {type: String},
    editLabel: {type: String},
    changeType: {type: String}
  },
  computed: {
    editLabelOrDefault() {
      return this.editLabel ? this.editLabel : this.$t('unitChanges.rowToolTip')
    },
    canChangeDefaultItem() {
      if(this.changeType === 'description' || this.changeType === 'contactName'
          || this.changeType === 'email' || this.changeType === 'phoneNumber') {
        return true
      }
      return false
    }
  },
  methods: {
    changeUnitDetail() {
      this.$emit('changeUnitItem', this.changeType)
    }
  }
}
</script>

<style scoped>

</style>